import React from "react";
import { Layout } from "components/Layout/Layout";
import { ProductProvider } from "./context";
import { ProductPage } from "./ProductPage";

export const ProductIndex = ({ currentOperationPage }) => {
  return (
    <ProductProvider>
      <Layout>
        <ProductPage currentOperationPage={currentOperationPage} />
      </Layout>
    </ProductProvider>
  );
};
